import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';

import type { DiscoveryAdDatePickerProps } from './DiscoveryAdDatePicker';

export const LazyDiscoveryAdDatePickerContainer: FunctionComponent<
  DiscoveryAdDatePickerProps
> = (props) => {
  const DiscoveryAdDatePickerContainer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "discovery-ad-date-picker-container" */ './DiscoveryAdDatePickerContainer'
      ),
    { namedImport: 'DiscoveryAdDatePickerContainer' },
  );
  return (
    <Suspense fallback={null}>
      <DiscoveryAdDatePickerContainer {...props} />
    </Suspense>
  );
};
